import * as React from 'react';
import { SidePanelMenu } from './SidePanelMenu';
import { Classes } from '../index';
import classNames from 'classnames';
import { SidePanelProps } from '../app/AppLayout';
import { ReactNode } from 'react';

export const ACTIVE_SIDE_PANEL = 'activeSidePanel';

export const SidePanel: React.FC<SidePanelProps> = ({
  items,
  panelClassName,
  menuClassName,
  panelWidth = 260,
}) => {
  const [currentKey, setCurrentKey] = React.useState(
    localStorage.getItem(ACTIVE_SIDE_PANEL) || undefined
  );
  const togglePanel = (key: string) => {
    if (key !== currentKey) {
      localStorage.setItem(ACTIVE_SIDE_PANEL, key);
      setCurrentKey(key);
    } else {
      localStorage.removeItem(ACTIVE_SIDE_PANEL);
      setCurrentKey(undefined);
    }
  };

  let content: ReactNode = null;
  if (currentKey) {
    //@ts-ignore
    content = items.find((item) => item.key === currentKey)?.content;
  }

  return (
    <>
      <SidePanelMenu
        items={items}
        className={menuClassName}
        onSelect={togglePanel}
        currentKey={currentKey}
      />
      {currentKey && (
        <div
          className={classNames(
            Classes.NAVBAR_SIDEPANEL_CONTENT,
            panelClassName
          )}
          style={{
            width: `${panelWidth}px`,
            maxWidth: `${panelWidth}px`,
            minWidth: `${panelWidth}px`,
          }}
        >
          {content}
        </div>
      )}
    </>
  );
};
